import { IconProps } from "./type";

const DepositIcon = ({ className }: IconProps) => {
  return (
    <svg
      width="66"
      height="66"
      viewBox="0 0 66 66"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <foreignObject x="0" y="0" width="0" height="0">
        <div></div>
      </foreignObject>
      <circle
        data-figma-bg-blur-radius="4"
        cx="33"
        cy="33"
        r="32.5"
        fill="#F4E7FF"
        stroke="#CB9CE0"
      />
      <path
        d="M37.5713 46.7148H23.857"
        stroke="#714790"
        stroke-width="2.5"
        stroke-linecap="round"
      />
      <path
        d="M41.2424 24.1118L24.2719 41.0824M23.4637 28.9605V41.8905H36.3937"
        stroke="#714790"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <defs>
        <clipPath id="bgblur_0_45_108184_clip_path" transform="translate(0 0)">
          <circle cx="33" cy="33" r="32.5" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DepositIcon;
